import { FC } from 'react';

import { ToolbarWrapper } from '../../ToolbarWrapper/ToolbarWrapper';
import { useDocumentOverviewContext } from '../Context';
import { DocumentTrainingButton, TrainingAlert } from '../DocumentTraining';
import { DocumentVariantRenderer } from '../DocumentVariantRenderer/DocumentVariantRenderer';

import styles from '../DocumentOverview.module.css';

type DocumentTabProps = {
  isMultiRootEditorEnabled?: boolean;
};

export const DocumentTab: FC<DocumentTabProps> = ({
  isMultiRootEditorEnabled = false,
}) => {
  const { widthRef } = useDocumentOverviewContext();

  return (
    <>
      {!isMultiRootEditorEnabled && (
        <ToolbarWrapper className={`${styles['document-overview__toolbar']}`} />
      )}
      <TrainingAlert />
      <DocumentVariantRenderer ref={widthRef} />
      <DocumentTrainingButton />
    </>
  );
};
